
const MainProductOptions = {
    store,
    name: 'MainProductApp',
    delimiters: ['${', '}'],
    compilerOptions:{
        isCustomElement: tag => ['quantity-input', 'cart-remove-button'].includes(tag)
    },
    data() {

        return {
            
        }

    },
    computed: {
        
    },
    created() {

    },
    methods:{

        getPriceSKU(sku){
            return sku
        },
        submitMainProduct($event){

            $event.preventDefault()

            const url = new URL(window.location);
            url.searchParams.set('email', this.email);
            url.searchParams.set('orderNumber', this.orderNumber);
            window.history.pushState({}, '', url);
            // window.history.pushState('/pages/rastrea-tu-pedido','Prueba', '/pages/rastrea-tu-pedido?query=test')
        }
    }

}

const MainProductApp = Vue.createApp(MainProductOptions)


const initProductApp = () => {

    mountVueComponent(MainProductApp, 'custom-price')
	mountVueComponent(MainProductApp, 'custom-price-a')
    mountVueComponent(MainProductApp, 'price-sku')
	mountVueComponent(MainProductApp, 'price-sku-a')
    mountVueComponent(MainProductApp, 'just-price-sku')
    
    MainProductApp.mount('#MainProductApp')
    MainProductApp.mount('#FeaturedProductApp')
}

initProductApp()

const ProductFormOptions = {
    store,
    name: 'ProductFormApp',
    delimiters: ['${', '}'],
    compilerOptions:{
        isCustomElement: tag => ['quantity-input', 'cart-remove-button'].includes(tag)
    },
    data() {

        return {
            
        }

    },
    computed: {
        
    },
    created() {

    },
    methods:{
        addToCart(id, qty){



            store.dispatch('addToCart', {id, qty})
            .then((response) => {
    
            })
        },
        getPriceSKU(sku){
            return sku
        },
        submitProductForm($event){

            $event.preventDefault()

            const url = new URL(window.location);
            url.searchParams.set('email', this.email);
            url.searchParams.set('orderNumber', this.orderNumber);
            window.history.pushState({}, '', url);
            // window.history.pushState('/pages/rastrea-tu-pedido','Prueba', '/pages/rastrea-tu-pedido?query=test')
        }
    }

}

const ProductFormApp = Vue.createApp(ProductFormOptions)


const initProductFormApp = () => {

    mountVueComponent(ProductFormApp, 'just-price-sku')
    
    ProductFormApp.mount('#ProductFormApp')
}

initProductFormApp() 
// MainProductApp.use(store)

function addToCartProductForm(id) {
    let searchParams = new URLSearchParams(window.location.search)

    const variant = searchParams.get('variant')

    const qty = document.querySelector('[name="quantity"]').value

    const newID = variant || id

    store.dispatch('addToCart', {id: newID, qty: qty || 1})

}
function addToCartProductFormMuestras(id) {

    let searchParams = new URLSearchParams(window.location.search)

    const variant = searchParams.get('variant')

    const qty = document.querySelector('[name="quantity"]').value

    const newID = variant || id

		const customAttributes = document.querySelectorAll('[name*=properties]')


		let properties = {}

		let skus =[];	
		let error = false


		customAttributes.forEach(element => {
			const [ property, sku ] = element.value.split('_')
			if (!property) {
				error = true
				element.classList.add('error')
			}else {
				
				element.classList.remove('error')
			}
			properties[element.name.replace('properties-', '').replace('_',' ')] = property
			skus.push(sku)
			// console.log('element :>> ', element.value);
		});

		if (error) {
			return
		}
		
		properties['_SKUs'] = skus.join(',')

    store.dispatch('addToCart', {id: newID, qty: qty || 1, properties})

}

function addToCartProductFormMuestrasWithLogin(id) {


	const puntos = window.store.state.customer.puntos
	const isCustomer = window.store.state.customer.isCustomer

	if(!isCustomer){

		Swal.fire({
			title: '¡Ya casi!',
			icon: 'warning',
			html:
				`<span class="" >
					<b>
						Ya casi te llevas tus muestras gratis.
						</b>
					<br>
					<br>
					Para poder agregarlas a tu carrito, debes inciar sesión. 🤩
				</span>
				`,
			showCloseButton: true,
			showCancelButton: true,
			focusConfirm: true,
			cancelButtonText:'Cancelar',
			confirmButtonText:'Ingresar a mi cuenta',
			confirmButtonColor: '#a0ff7f',
		}).then((result) => {
				
			if (result.value ) {
				window.location.href = "/account/login?return_url="+window.location.pathname
			}else if (result.dismiss == 'cancel'){
					
					// store.state.cart.data.items.filter(x=> ['PQ-DIST1.1','PQ-TND'].includes(x.sku) ).map(x=>{
																					
					// 		this.updateCart(x.id,0)

					// })
			}
		})
		return
	}else if(puntos > 0 && false){

		Swal.fire({
			title: '¡Ups!',
			icon: 'warning',
			html:
				`<span class="" >
					Las muestras de regalo son exclusivas para tu primer pedido.
				</span>
				`,
			showCloseButton: true,
			showCancelButton: false,
			focusConfirm: true,
			confirmButtonText:'Continuar comprando',
			confirmButtonColor: '#a0ff7f',
		})
		return
	}

    let searchParams = new URLSearchParams(window.location.search)

    const variant = searchParams.get('variant')

    const qty = 1//document.querySelector('[name="quantity"]').value

    const newID = variant || id

		const customAttributes = document.querySelectorAll('[name*=properties]')


		let properties = {}

		let skus =[];	
		let error = false

		let erros = []

		customAttributes.forEach(element => {
			const [ property, sku ] = element.value.split('_')
			if (!property) {
				error = true
				element.classList.add('error')
			}else {
				
				element.classList.remove('error')
			}
			properties[element.name.replace('properties-', '').replace('_',' ')] = property
			skus.push(sku)
			// console.log('element :>> ', element.value);
		});

		if (error) {
			return
		}
		
		properties['_SKUs'] = skus.join(',')

		const removeMuestras = function(newID, properties){

			store.dispatch('updateCart', {id: newID, qty: 0})

			setTimeout(() => {
				if (store.state.cart.data.items.find(x=>x.id == id)) {
					removeMuestras(newID, properties)
				}else{

					store.dispatch('addToCart', {id: newID, qty: qty || 1, properties})
				}
			}, 300);
		}
		// if(store.state.cart.items)
		if(store.state.cart.data.items.find(x=>x.id == id)){
			Swal.fire({
				title: '¡Ups!',
				icon: 'warning',
				html:
					`<span class="" >
						Solo puedes agregar una muestra de regalo.
					</span>
					`,
				showCloseButton: true,
				showCancelButton: true,
				focusConfirm: true,
				cancelButtonText:'No actualizar muestras',
				confirmButtonText:'Actualizar muestras',
				confirmButtonColor: '#a0ff7f',
			}).then((result) => {
				
				if (result.value ) {

					removeMuestras(newID,properties)

				}else if (result.dismiss == 'cancel'){
						
				}
			})
		}else{

			

			store.dispatch('addToCart', {id: newID, qty: qty || 1, properties})
		}

}

function setCookie(name,value,days) {
	var expires = "";
	if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
const getCookie = function(name) {
	var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	if (match) return match[2];
}

function changeMuestrasSelector(event){
	let cookieMuestras = getCookie('muestras_selector') || ''
	let muestras = []

	const selectorsMuestras = document.querySelectorAll('[name*=properties-Muestras_]')
	selectorsMuestras.forEach((selector, idx) => {

		if(selector && selector.value){

			muestras.push(selector.value.split('PQ-M-')[1].split('-X')[0])
		}else{
			muestras.push('')
		}
		
	});

	setCookie('muestras_selector',muestras.join(','))

}